<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\manageLiveCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① Khi có khóa học online mới thì sẽ có thông báo xuất hiện trên góc phải của icon [Khóa học online]</p>
                    <p>&nbsp;Nhấn vào icon [Khóa học online] để xem danh sách các khóa học online</p>
                    <p>&nbsp;Các khóa học online sẽ được hiển thị theo mặc định trạng thái là "Tất cả" và thời gian diễn ra khóa học là ngày hiện tại.</p>
                    <p>② Tuy nhiên, học viên có thể tìm kiếm khóa học theo từ khóa</p>
                    <p>③ Tìm kiếm khóa học theo trạng thái: Tất cả, Chưa bắt đầu, Đang dạy, Kết thúc</p>
                    <p>④ Tìm kiếm khóa học theo thời gian diễn ra khóa học: Từ ngày ~ Đến ngày ~</p>
                    <p>⑤ Sau đó, nhấn nút tìm kiếm</p>
                    <p>⑥ Sau khi tìm kiếm khóa học theo các điều kiện tìm kiếm mà bạn muốn, thì có thể nhấn vào nút [Làm mới] để quay về trạng thái mặc định.</p>
                    <p>&nbsp;Tức là tất cả các khóa học diễn ra trong ngày hiện tại sẽ được hiển thị.</p>
                    <p>⑦ Tải về danh sách điểm danh của tất cả các khóa học online đang bắt đầu hoặc đã kết thúc</p>
                    <p>⑧ Tải về danh sách điểm danh của khóa học online</p>
                    <p>⑨ Danh sách học viên tham gia khóa học</p>
                    <p>⑩ Danh sách học viên chưa tham gia khóa học</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/manageLiveCourse_manual.vue